import React from "react";

const defaultContentSelector = "table";

/** Tracks whether a scroll container's content exceeds its visible height. */
export const useContainerOverflow = (
    enabled: boolean,
    contentDeps: React.DependencyList,
    contentSelector: string = defaultContentSelector,
) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const [contentOverflows, setContentOverflows] = React.useState(false);

    React.useLayoutEffect(() => {
        const container = ref.current;
        if (!container || !enabled) {
            setContentOverflows(false);
            return;
        }

        const updateOverflow = () => {
            setContentOverflows(container.scrollHeight > container.clientHeight + 1);
        };

        updateOverflow();

        const resizeObserver = new ResizeObserver(updateOverflow);
        resizeObserver.observe(container);

        const contentElement = container.querySelector(contentSelector);
        if (contentElement) {
            resizeObserver.observe(contentElement);
        }

        return () => resizeObserver.disconnect();
    }, [enabled, contentSelector, ...contentDeps]);

    return { ref, contentOverflows };
};
